// import { Link, Table, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import LocalizedStrings from "react-localization";
// import { TutorialModalLink } from '../components/TutorialModalTrigger';
const BLOCKCHAIN_NAME_CAMEL = "Avalanche";
const COIN_SYMBOL = "AVAX"; //ETH

if (!window.walletStrings) {
  const walletStrings = new LocalizedStrings({
    en: {
      appName: "Ai-Fi Wallet",
      learn_more: "Learn more",
      retry: "Retry",
      recovering: "Recovering Wallet ...",
      error: {
        not_match:
          "Please enter the exact key info from last time you saved the wallet",
      },
      ui: {
        create: {
          title: "Add New Account",
          name: "Name",
          name_placeholder: "Please enter name here",
          name_taken: "The name is taken",
          cancel: "Cancel",
          create: "Create",
          name_too_long: "The name length exceeds 100",
        },
        import: {
          title: "Import Select Accounts from an Existing Crypton",
          entropy_salt: "Entropy Salt",
          entropy_salt_placeholder: "Please enter entropy salt",
          passphrase: "Passphrase",
          passphrase_placeholder: "Please enter passphrase",
          import_wallets: "Import Accounts",
          name: "Name",
          wallet: "Account",
          already_imported: "Account has already been imported",
          name_taken: "The name is taken",
          name_available: "The name is available",
          name_too_long: "The name length exceeds 100",
          identical: "Importing from the same wallet is not allowed",
          cancel: "Cancel",
          next: "Next",
          import: "Import",
        },
        override: {
          title: "Warning",
          message:
            "This Crypton already exists. Do you want to overwrite it? Please note that by doing so, you will lose all cryptocurrencies in the wallet as well as all past emails associated with the Crypton.",
          button: {
            yes: "Override",
            no: "No",
          },
        },
        one_click: {
          title: "1-Click Resume",
          description:
            "This is a streamlined workflow to recover your previously established PlexiMail session without resetting any session parameters, such as Privacy Level, PIN, or the Web3Storage configuration. The standard email verification is still required.",
          note: "* If the Privacy Level is inconsistent with the current running platform, it will be modified to suit the new environment (but only for this specific instance).",
          get_started: "Get Started",
        },
        choose: {
          title: "The Ai-Fi Wallet",
          description_1: `Congratulations on creating your secure PlexiMail identity! The trustless nature of the PlexiMail smart contract on the ICP blockchain ensures any hijack attempts against your PlexiMail Identity are detectable. You can also integrate with other smart contracts for varying levels of security and auditability by adjusting your Settings.`,
          description_2: `<>Next, we will configure a custom wallet to further strengthen the confidentiality and anonymity of your PlexiMail activities.`,
          description_3: `Important: This custom wallet is not for regular cryptocurrency transactions. It's a technological tool designed to limit traceability across the blockchain and protect your identity. `,

          get_started: "Get Started",
        },
        config: {
          title: "Create New",
          create_new: "Create New",
          recover: "Recover",
          back: "Back",
          network: {
            title: "Select Blockchain",
            description:
              "PlexiMail adopts the self-executing smart contract to register and protect the PlexiMail addresses/identities. Once registered, the authenticity of a PlexiMail identity becomes auditable without a central authority and inalterable without owning the private key.",
            mainnet: "Mainnet",
            mainnet_note:
              "* Pay AVAX crypto to register your PlexiMail addresses on the Avalanche Mainnet.",
            testnet: "Testnet",
            testnet_note:
              "* Conduct a test run on the Fuji Testnet without incurring AVAX charges. Your PlexiMail addresses are not fully protected in this case. You may upgrade your run to the Mainnet later.",
            unverified: "Trial without Smart Contract",
            unverified_node:
              "* Skip the smart contract registration altogether. Your PlexiMail identities will be checkmarked as \"unverified\". You may upgrade your trial to run with the smart contract later.",
          },
          create: {
            title: "Create Screen Lock PIN Code",
            pin_code: "Please enter the new PIN",
            confirm_pin_code: "Please confirm the PIN",
            creating: "Creating new wallet and session...",
            note: "* PIN is a 6-digit secret used to unlock the cached session after idle timeout.",
            pin_not_match: "The two PIN codes entered do not match.",
            back: "Back",
          },
          recovery: {
            title: "Wallet Recovery",
            entropy_salt: "Entropy Entender",
            passphrase: "Passphrase",
            recover: "Recover",
            back: "Back",
            safari:
              "Currently the backup with W3:UI configuration is not supported on Safari browser.",
            token_not_exists:
              "Token does not exist, please try again later with another password.",
          },
        },
        unlock: {
          title: "Unlock Local Session with PIN",
          unlocking: "Unlocking...",
          note: "* PIN is a 6-digit secret used to unlock the cached session after idle timeout.",
          never_used:
            "This wallet has never been used and can be safely discarded",
          discard: "Discard this Wallet",
        },
        connect: {
          title: "Your Wallet, Your Addresses",
          description: `Set the following address as the default address.`,
          connect: "Set",
          deny: "Deny",
        },
        wallet: {
          copy: "Copy Address",
          advanced: "Advanced",
          create: "Create New Account",
          import: "Import Accounts",

          buy: `Buy ${COIN_SYMBOL} with Plexi Token(s)`,
          migrate: "Liquidate Assets",
        },
        sign_tx: {
          title: "Register Identity Address",
          description_1: `Your PlexiMail address is registered on the ${BLOCKCHAIN_NAME_CAMEL} Blockchain through PlexiMail Smart Contract. It is anonymous but auditable.`,
          description_2: `
                Benefits of Smart Contract:<br />
                1. Registered address is not updatable without the private key. <br />
                2. All updates are recorded and immutable. <br />
                3. It is trustless. <br />`,
          description_3: `To enjoy all these benefits, you need to make payments to the ${BLOCKCHAIN_NAME_CAMEL} Blockchain. Currently, only the registration incurs a one-time fee.`,
          address: "Address: ",
          identity_key: "Identity Key: ",
          key_server: "Key Store Server: ",
          estimated_cost: "Estimated Cost: ",
          max_cost: "Max Cost: ",
          within_30_seconds: "* Should take no more than 30 seconds: ",
          cancel: "Cancel",
          publish: "Register",
        },
        sign: {
          title: "Verify Account Ownership",
          description:
            "This is a standard Public Key Cryptographic challenge from the key server to verify your PlexiMail identity. This challenge text must be correctly signed with the private key in your wallet.",
          cancel: "Cancel",
          sign: "Sign & Verify",
        },
        backup: {
          title: "Crypton Double-Locks Your Session Data",
          backup_required:
            "This is to self-manage your wallet, session contexts and messaging history.",
          next: "Next",
          entropy_salt: "Entropy Extender",
          entropy_salt_placeholder: "e.g. PlexiMail maximizes privacy ...",
          entropy_salt_note:
            "* Extender leverages physical security, eliminating memorization. Write down your code, store securely (vault, desk, wallet, etc.). The underline adopts the same color scheme.",
          recovery_passphrase: "Recovery Passphrase",
          recovery_passphrase_placeholder:
            "e.g. PlexiMail provides traceless privacy ...",
          confirm_recovery_passphrase: "Confirm Recovery Passphrase",
          backup: "Generate",
          update: "Confirm",
          back: "Back",
          token_exists:
            "Configuration database already exists. Please try a different one.",
          passphrase_not_match: "The two Passphrases entered do not match.",
          passphrase_note:
            'A memorized sequence of words or text used to unlock secure access. Example: "ai-fi.cc - PlexiMail keeps it private". Type to see the underline color change based on your input strength. Green indicates acceptable strength.',
          description_1:
            "Crypton is a software apparatus that protects your wallet, online contexts and messaging history with two independent locks, each based on a passphrase of high andomness or entropy. Crypton persists your PlexiMail sessions over time and resides anonymously in the PlexiMail Registra hidden in plain sight. It is essential to handle these passphrases with extreme care to avoid any potential loss of session data. You and you alone have access to it.",
          description_2:
            'The recovery passphrase should consist of up to 100 bits of randomness and be memorized. It is further reinforced by the second key phrase, called the "Entropy Extender," securely stored in a designated location (e.g., lockbox, pocket wallet, drawer, etc.), relying on physical security for protection. The Entropy Extender should incorporate as much randomness as possible, without requiring memorization. Together, these key phrases provide a level of security comparable to or greater than that of the private keys used to safeguard significant fortunes across all cryptocurrency blockchains.',
          description_3: "",
          description_4:
            "A new account with an individualized PlexiMail address is ready. Confirm with the double keys to introduce it into your wallet.",
          description_5:
            "An account created with a new PlexiMail address is ready. Confirm to add it to your wallet using the wallet crypton keys.",
          description_6:
            "The new account name is ready. Confirm with their wallet crypton keys.",
          succeed: "Successfully completed",
          close: "Close",
          new_account:
            'The new account is successfully added. Click "Next" to setup PlexiMail with the new account',
          import_account: "The selected accounts have been imported.",
          name_changed: "The account name has been changed.",
        },
        change_pin: {
          reset_title: "Reset Screen Lock PIN on Reentry",
          title: "Set Screen Lock PIN Code",
          pin_code: "Please enter the PIN",
          confirm_pin_code: "Please confirm the PIN",
          changing: "Configuring the PIN Code...",
          note: "*  PIN is a 6-digit secret to unlock the cached session after idle timeout.",
          back: "Back",
        },
        migrate: {
          title: "Liquidate Assets",
          address: "Please enter the receiving account",
          note: "* Liquidate all current assets into the specified account.",
          migrate: "Liquidate",
        },
        change_w3s_api_token: {
          title: "Change Web3Storage",
          description:
            "Paste your Web3 Storage token here in order for PlexiMail to locate your private storage.",
          placeholder: "Enter Web3 Storage API Token here",
          changing: "Changing...",
          note: "All your PlexiMail data are stored in your own private storage space acquired from Web3Storage. Although it is in plain sight, it is virtually anonymous and fully encrypted through dynamic keys from your own wallet with strength equivalent to any public blockchain transaction keys.",
          apply: "Apply",
        },
        selector: {
          title: "Switch Account",
        },
      },
    },
    zh: {
      appName: "Ai-Fi钱包",
      learn_more: "了解更多",
      retry: "重试",
      recovering: "恢复钱包中...",
      error: {
        not_match: "请输入与上次保存钱包时完全相同的密钥信息",
      },
      ui: {
        create: {
          title: "添加新账户",
          name: "名称",
          name_placeholder: "请在这里输入名称",
          name_taken: "该名称已被使用",
          cancel: "取消",
          create: "创建",
          name_too_long: "名称长度超过100个字符",
        },
        import: {
          title: "从现有Crypton导入选定账户",
          entropy_salt: "熵盐",
          entropy_salt_placeholder: "请输入熵盐",
          passphrase: "口令",
          passphrase_placeholder: "请输入口令",
          import_wallets: "导入账户",
          name: "名称",
          wallet: "账户",
          already_imported: "账户已被导入",
          name_taken: "该名称已被使用",
          name_available: "该名称可用",
          name_too_long: "名称长度超过100个字符",
          identical: "不允许从相同的钱包导入",
          cancel: "取消",
          next: "下一步",
          import: "导入",
        },
        override: {
          title: "警告",
          message:
            "此Crypton已存在。您想覆盖它吗？请注意，这样做将导致您丢失钱包中的所有加密货币以及与该Crypton相关的所有历史电子邮件。",
          button: {
            yes: "覆盖",
            no: "不",
          },
        },
        one_click: {
          title: "一键恢复",
          description:
            "这是一个简化的工作流程，用于恢复您之前建立的PlexiMail会话，而无需重置任何会话参数，例如隐私级别、PIN或Web3Storage配置。仍需要进行标准的电子邮件验证。",
          note: "* 如果隐私级别与当前运行平台不一致，它将被修改以适应新环境（但仅适用于此特定实例）。",
          get_started: "开始",
        },
        choose: {
          title: "Ai-Fi钱包",
          description_1: `恭喜您创建了安全的PlexiMail身份！PlexiMail智能合约在ICP区块链上的无信任特性确保了任何针对您PlexiMail身份的劫持尝试都是可检测的。您还可以通过调整设置与其他智能合约集成，以实现不同级别的安全性和可审计性。`,
          description_2: `<>接下来，我们将配置一个自定义钱包，以进一步加强您PlexiMail活动的机密性和匿名性。`,
          description_3: `重要提示：此自定义钱包不用于常规加密货币交易。它是一种技术工具，旨在限制区块链上的可追溯性并保护您的身份。`,
          get_started: "开始",
        },
        config: {
          title: "创建新钱包",
          create_new: "创建新钱包",
          recover: "恢复",
          back: "返回",
          network: {
            title: "选择区块链",
            description:
              "PlexiMail采用自执行智能合约来注册和保护PlexiMail地址/身份。一旦注册，PlexiMail身份的真实性就变得可审计，无需中央权威机构，并且在不拥有私钥的情况下不可更改。",
            mainnet: "主网",
            mainnet_note:
              "* 支付AVAX加密货币以在Avalanche主网上注册您的PlexiMail地址。",
            testnet: "测试网",
            testnet_note:
              "* 在Fuji测试网上进行测试运行，无需支付AVAX费用。在这种情况下，您的PlexiMail地址未受到充分保护。您可以稍后将运行升级到主网。",
            unverified: "不使用智能合约的试用",
            unverified_node:
              "* 完全跳过智能合约注册。您的PlexiMail身份将被标记为\"未验证\"。您可以稍后将试用升级为使用智能合约运行。",
          },
          create: {
            title: "创建屏幕锁定PIN码",
            pin_code: "请输入新PIN",
            confirm_pin_code: "请确认PIN",
            creating: "正在创建新钱包和会话...",
            note: "* PIN是一个6位数的秘密，用于在空闲超时后解锁缓存的会话。",
            pin_not_match: "两次输入的PIN码不匹配。",
            back: "返回",
          },
          recovery: {
            title: "钱包恢复",
            entropy_salt: "熵扩展器",
            passphrase: "口令",
            recover: "恢复",
            back: "返回",
            safari: "目前，Safari浏览器不支持W3:UI配置的备份。",
            token_not_exists: "令牌不存在，请稍后使用其他密码重试。",
          },
        },
        unlock: {
          title: "使用PIN解锁本地会话",
          unlocking: "正在解锁...",
          note: "* PIN是一个6位数的秘密，用于在空闲超时后解锁缓存的会话。",
          never_used: "此钱包从未被使用，可以安全地丢弃",
          discard: "丢弃此钱包",
        },
        connect: {
          title: "您的钱包，您的地址",
          description: `将以下地址设置为默认地址。`,
          connect: "设置",
          deny: "拒绝",
        },
        wallet: {
          copy: "复制地址",
          advanced: "高级",
          create: "创建新账户",
          import: "导入账户",
          buy: `使用Plexi Token购买${COIN_SYMBOL}`,
          migrate: "清算资产",
        },
        sign_tx: {
          title: "注册身份地址",
          description_1: `您的PlexiMail地址通过PlexiMail智能合约注册在${BLOCKCHAIN_NAME_CAMEL}区块链上。它是匿名的但可审计的。`,
          description_2: `
                智能合约的好处：<br />
                1. 注册地址在没有私钥的情况下不可更新。<br />
                2. 所有更新都被记录且不可变。<br />
                3. 它是无信任的。<br />`,
          description_3: `要享受所有这些好处，您需要向${BLOCKCHAIN_NAME_CAMEL}区块链支付费用。目前，只有注册会产生一次性费用。`,
          address: "地址：",
          identity_key: "身份密钥：",
          key_server: "密钥存储服务器：",
          estimated_cost: "预计费用：",
          max_cost: "最大费用：",
          within_30_seconds: "* 应该不超过30秒：",
          cancel: "取消",
          publish: "注册",
        },
        sign: {
          title: "验证账户所有权",
          description:
            "这是来自密钥服务器的标准公钥加密挑战，用于验证您的PlexiMail身份。此挑战文本必须使用您钱包中的私钥正确签名。",
          cancel: "取消",
          sign: "签名并验证",
        },
        backup: {
          title: "Crypton双重锁定您的会话数据",
          backup_required: "这是为了自管理您的钱包、会话上下文和消息历史。",
          next: "下一步",
          entropy_salt: "熵扩展器",
          entropy_salt_placeholder: "例如，PlexiMail最大化隐私...",
          entropy_salt_note:
            "* 扩展器利用物理安全性，消除了记忆的需要。写下您的代码，安全存储（保险箱、书桌、钱包等）。下划线采用相同的配色方案。",
          recovery_passphrase: "恢复口令",
          recovery_passphrase_placeholder: "例如，PlexiMail提供无痕隐私...",
          confirm_recovery_passphrase: "确认恢复口令",
          backup: "生成",
          update: "确认",
          back: "返回",
          token_exists: "配置数据库已存在。请尝试使用其他数据库。",
          passphrase_not_match: "两次输入的口令不匹配。",
          passphrase_note:
            "一个记忆的单词或文本序列，用于解锁安全访问。例如：\"ai-fi.cc - PlexiMail保持隐私\"。输入时会看到下划线颜色根据您的输入强度变化。绿色表示可接受的强度。",
          description_1:
            "Crypton是一种软件装置，通过两个独立的锁保护您的钱包、在线上下文和消息历史，每个锁都基于一个高随机性或熵的口令。Crypton使您的PlexiMail会话持久存在，并匿名驻留在PlexiMail注册表中，隐藏在众目睽睽之下。必须极其小心地处理这些口令，以避免任何潜在的会话数据丢失。只有您自己可以访问它。",
          description_2:
            "恢复口令应包含多达100位的随机性，并被记住。它进一步由第二个密钥短语（称为\"熵扩展器\"）加强，该短语安全存储在指定位置（例如，保险箱、口袋钱包、抽屉等），依靠物理安全性进行保护。熵扩展器应尽可能多地包含随机性，而无需记忆。结合起来，这些密钥短语提供了与用于保护所有加密货币区块链上巨额财富的私钥相当或更高的安全性水平。",
          description_3: "",
          description_4:
            "一个带有个性化PlexiMail地址的新账户已准备就绪。使用双重密钥确认以将其引入您的钱包。",
          description_5:
            "一个带有新PlexiMail地址的账户已创建。确认以使用钱包Crypton密钥将其添加到您的钱包。",
          description_6:
            "新账户名称已准备就绪。使用他们的钱包Crypton密钥确认。",
          succeed: "成功完成",
          close: "关闭",
          new_account:
            "新账户已成功添加。点击\"下一步\"以使用新账户设置PlexiMail",
          import_account: "选定的账户已导入。",
          name_changed: "账户名称已更改。",
        },
        change_pin: {
          reset_title: "在重新进入时重置屏幕锁定PIN",
          title: "设置屏幕锁定PIN码",
          pin_code: "请输入PIN",
          confirm_pin_code: "请确认PIN",
          changing: "正在配置PIN码...",
          note: "* PIN是一个6位数的秘密，用于在空闲超时后解锁缓存的会话。",
          back: "返回",
        },
        migrate: {
          title: "清算资产",
          address: "请输入接收账户",
          note: "* 将所有当前资产清算到指定的账户。",
          migrate: "清算",
        },
        change_w3s_api_token: {
          title: "更改Web3Storage",
          description:
            "将您的Web3 Storage令牌粘贴在这里，以便PlexiMail可以定位您的私有存储。",
          placeholder: "在此处输入Web3 Storage API令牌",
          changing: "正在更改...",
          note: "您的所有PlexiMail数据都存储在您从Web3Storage获取的私有存储空间中。虽然它公开可见，但实际上是匿名的，并通过您自己钱包中的动态密钥完全加密，其强度等同于任何公共区块链交易密钥。",
          apply: "应用",
        },
        selector: {
          title: "切换账户",
        },
      },
    },
    es: {
      appName: "Ai-Fi Wallet",
      learn_more: "Más información",
      retry: "Reintentar",
      recovering: "Recuperando billetera ...",
      error: {
        not_match:
          "Por favor, ingrese la información exacta de la clave de la última vez que guardó la billetera",
      },
      ui: {
        create: {
          title: "Agregar nueva cuenta",
          name: "Nombre",
          name_placeholder: "Por favor, ingrese el nombre aquí",
          name_taken: "El nombre ya está en uso",
          cancel: "Cancelar",
          create: "Crear",
          name_too_long: "La longitud del nombre excede los 100 caracteres",
        },
        import: {
          title: "Importar cuentas seleccionadas de un Crypton existente",
          entropy_salt: "Sal de entropía",
          entropy_salt_placeholder: "Por favor, ingrese la sal de entropía",
          passphrase: "Frase de acceso",
          passphrase_placeholder: "Por favor, ingrese la frase de acceso",
          import_wallets: "Importar cuentas",
          name: "Nombre",
          wallet: "Cuenta",
          already_imported: "La cuenta ya ha sido importada",
          name_taken: "El nombre ya está en uso",
          name_available: "El nombre está disponible",
          name_too_long: "La longitud del nombre excede los 100 caracteres",
          identical: "No se permite importar desde la misma billetera",
          cancel: "Cancelar",
          next: "Siguiente",
          import: "Importar",
        },
        override: {
          title: "Advertencia",
          message:
            "Este Crypton ya existe. ¿Desea sobrescribirlo? Tenga en cuenta que al hacerlo, perderá todas las criptomonedas en la billetera, así como todos los correos electrónicos anteriores asociados con el Crypton.",
          button: {
            yes: "Sobrescribir",
            no: "No",
          },
        },
        one_click: {
          title: "Reanudar con 1 clic",
          description:
            "Este es un flujo de trabajo simplificado para recuperar su sesión de PlexiMail previamente establecida sin restablecer ningún parámetro de sesión, como el nivel de privacidad, el PIN o la configuración de Web3Storage. Aún se requiere la verificación estándar de correo electrónico.",
          note: "* Si el nivel de privacidad no es consistente con la plataforma actual en ejecución, se modificará para adaptarse al nuevo entorno (pero solo para esta instancia específica).",
          get_started: "Comenzar",
        },
        choose: {
          title: "La billetera Ai-Fi",
          description_1: `¡Felicidades por crear su identidad segura de PlexiMail! La naturaleza sin confianza del contrato inteligente de PlexiMail en la blockchain ICP garantiza que cualquier intento de secuestro contra su identidad de PlexiMail sea detectable. También puede integrarse con otros contratos inteligentes para diferentes niveles de seguridad y auditabilidad ajustando su configuración.`,
          description_2: `A continuación, configuraremos una billetera personalizada para fortalecer aún más la confidencialidad y el anonimato de sus actividades en PlexiMail.`,
          description_3: `Importante: Esta billetera personalizada no es para transacciones regulares de criptomonedas. Es una herramienta tecnológica diseñada para limitar la trazabilidad a través de la blockchain y proteger su identidad.`,
          get_started: "Comenzar",
        },
        config: {
          title: "Crear nueva",
          create_new: "Crear nueva",
          recover: "Recuperar",
          back: "Atrás",
          network: {
            title: "Seleccionar blockchain",
            description:
              "PlexiMail adopta el contrato inteligente autoejecutable para registrar y proteger las direcciones/identidades de PlexiMail. Una vez registradas, la autenticidad de una identidad de PlexiMail se vuelve auditable sin una autoridad central y inalterable sin poseer la clave privada.",
            mainnet: "Mainnet",
            mainnet_note:
              "* Pague criptomonedas AVAX para registrar sus direcciones de PlexiMail en la Mainnet de Avalanche.",
            testnet: "Testnet",
            testnet_note:
              "* Realice una ejecución de prueba en la Testnet Fuji sin incurrir en cargos de AVAX. Sus direcciones de PlexiMail no están completamente protegidas en este caso. Puede actualizar su ejecución a la Mainnet más adelante.",
            unverified: "Prueba sin contrato inteligente",
            unverified_node:
              "* Omita completamente el registro del contrato inteligente. Sus identidades de PlexiMail serán marcadas como \"no verificadas\". Puede actualizar su prueba para ejecutarse con el contrato inteligente más adelante.",
          },
          create: {
            title: "Crear código PIN de bloqueo de pantalla",
            pin_code: "Por favor, ingrese el nuevo PIN",
            confirm_pin_code: "Por favor, confirme el PIN",
            creating: "Creando nueva billetera y sesión...",
            note: "* El PIN es un secreto de 6 dígitos utilizado para desbloquear la sesión caché después del tiempo de inactividad.",
            pin_not_match: "Los dos códigos PIN ingresados no coinciden.",
            back: "Atrás",
          },
          recovery: {
            title: "Recuperación de billetera",
            entropy_salt: "Extensor de entropía",
            passphrase: "Frase de acceso",
            recover: "Recuperar",
            back: "Atrás",
            safari:
              "Actualmente, la copia de seguridad con la configuración de W3:UI no es compatible con el navegador Safari.",
            token_not_exists:
              "El token no existe, intente nuevamente más tarde con otra contraseña.",
          },
        },
        unlock: {
          title: "Desbloquear sesión local con PIN",
          unlocking: "Desbloqueando...",
          note: "* El PIN es un secreto de 6 dígitos utilizado para desbloquear la sesión caché después del tiempo de inactividad.",
          never_used:
            "Esta billetera nunca ha sido utilizada y puede descartarse de manera segura",
          discard: "Descartar esta billetera",
        },
        connect: {
          title: "Su billetera, sus direcciones",
          description: `Establecer la siguiente dirección como la dirección predeterminada.`,
          connect: "Establecer",
          deny: "Denegar",
        },
        wallet: {
          copy: "Copiar dirección",
          advanced: "Avanzado",
          create: "Crear nueva cuenta",
          import: "Importar cuentas",
          buy: `Comprar ${COIN_SYMBOL} con Plexi Token(s)`,
          migrate: "Liquidar activos",
        },
        sign_tx: {
          title: "Registrar dirección de identidad",
          description_1: `Su dirección de PlexiMail está registrada en la blockchain ${BLOCKCHAIN_NAME_CAMEL} a través del contrato inteligente de PlexiMail. Es anónima pero auditable.`,
          description_2: `
                Beneficios del contrato inteligente:<br />
                1. La dirección registrada no es actualizable sin la clave privada. <br />
                2. Todas las actualizaciones se registran y son inmutables. <br />
                3. Es sin confianza. <br />`,
          description_3: `Para disfrutar de todos estos beneficios, debe realizar pagos a la blockchain ${BLOCKCHAIN_NAME_CAMEL}. Actualmente, solo el registro incurre en una tarifa única.`,
          address: "Dirección: ",
          identity_key: "Clave de identidad: ",
          key_server: "Servidor de almacenamiento de claves: ",
          estimated_cost: "Costo estimado: ",
          max_cost: "Costo máximo: ",
          within_30_seconds: "* Debería tomar no más de 30 segundos: ",
          cancel: "Cancelar",
          publish: "Registrar",
        },
        sign: {
          title: "Verificar propiedad de la cuenta",
          description:
            "Este es un desafío criptográfico estándar de clave pública del servidor de claves para verificar su identidad de PlexiMail. Este texto de desafío debe firmarse correctamente con la clave privada en su billetera.",
          cancel: "Cancelar",
          sign: "Firmar y verificar",
        },
        backup: {
          title: "Crypton protege sus datos de sesión con doble bloqueo",
          backup_required:
            "Esto es para autogestionar su billetera, contextos de sesión e historial de mensajes.",
          next: "Siguiente",
          entropy_salt: "Extensor de entropía",
          entropy_salt_placeholder:
            "p. ej. PlexiMail maximiza la privacidad ...",
          entropy_salt_note:
            "* El extensor aprovecha la seguridad física, eliminando la memorización. Anote su código, guárdelo de manera segura (caja fuerte, escritorio, billetera, etc.). El subrayado adopta el mismo esquema de color.",
          recovery_passphrase: "Frase de acceso de recuperación",
          recovery_passphrase_placeholder:
            "p. ej. PlexiMail proporciona privacidad sin rastros ...",
          confirm_recovery_passphrase:
            "Confirmar frase de acceso de recuperación",
          backup: "Generar",
          update: "Confirmar",
          back: "Atrás",
          token_exists:
            "La base de datos de configuración ya existe. Por favor, intente con una diferente.",
          passphrase_not_match:
            "Las dos frases de acceso ingresadas no coinciden.",
          passphrase_note:
            'Una secuencia memorizada de palabras o texto utilizada para desbloquear el acceso seguro. Ejemplo: "ai-fi.cc - PlexiMail mantiene la privacidad". Escriba para ver el cambio de color del subrayado según la fortaleza de su entrada. Verde indica fortaleza aceptable.',
          description_1:
            "Crypton es un aparato de software que protege su billetera, contextos en línea e historial de mensajes con dos cerraduras independientes, cada una basada en una frase de acceso de alta aleatoriedad o entropía. Crypton persiste sus sesiones de PlexiMail a lo largo del tiempo y reside de forma anónima en el Registro de PlexiMail, oculto a simple vista. Es esencial manejar estas frases de acceso con sumo cuidado para evitar cualquier posible pérdida de datos de sesión. Solo usted tiene acceso a ello.",
          description_2:
            'La frase de acceso de recuperación debe consistir en hasta 100 bits de aleatoriedad y ser memorizada. Se refuerza aún más con la segunda frase clave, llamada "Extensor de entropía", almacenada de manera segura en una ubicación designada (por ejemplo, caja fuerte, billetera de bolsillo, cajón, etc.), confiando en la seguridad física para su protección. El Extensor de entropía debe incorporar tanta aleatoriedad como sea posible, sin requerir memorización. Juntas, estas frases clave proporcionan un nivel de seguridad comparable o superior al de las claves privadas utilizadas para salvaguardar fortunas significativas en todas las blockchains de criptomonedas.',
          description_3: "",
          description_4:
            "Una nueva cuenta con una dirección de PlexiMail individualizada está lista. Confirme con las claves dobles para introducirla en su billetera.",
          description_5:
            "Se ha creado una cuenta con una nueva dirección de PlexiMail. Confirme para agregarla a su billetera utilizando las claves del Crypton de la billetera.",
          description_6:
            "El nombre de la nueva cuenta está listo. Confirme con sus claves del Crypton de la billetera.",
          succeed: "Completado con éxito",
          close: "Cerrar",
          new_account:
            'La nueva cuenta se ha agregado con éxito. Haga clic en "Siguiente" para configurar PlexiMail con la nueva cuenta',
          import_account: "Las cuentas seleccionadas han sido importadas.",
          name_changed: "El nombre de la cuenta ha sido cambiado.",
        },
        change_pin: {
          reset_title: "Restablecer PIN de bloqueo de pantalla al reingresar",
          title: "Establecer código PIN de bloqueo de pantalla",
          pin_code: "Por favor, ingrese el PIN",
          confirm_pin_code: "Por favor, confirme el PIN",
          changing: "Configurando el código PIN...",
          note: "* El PIN es un secreto de 6 dígitos para desbloquear la sesión caché después del tiempo de inactividad.",
          back: "Atrás",
        },
        migrate: {
          title: "Liquidar activos",
          address: "Por favor, ingrese la cuenta receptora",
          note: "* Liquidar todos los activos actuales en la cuenta especificada.",
          migrate: "Liquidar",
        },
        change_w3s_api_token: {
          title: "Cambiar Web3Storage",
          description:
            "Pegue su token de Web3 Storage aquí para que PlexiMail pueda localizar su almacenamiento privado.",
          placeholder: "Ingrese el token API de Web3 Storage aquí",
          changing: "Cambiando...",
          note: "Todos sus datos de PlexiMail se almacenan en su propio espacio de almacenamiento privado adquirido de Web3Storage. Aunque está a la vista, es virtualmente anónimo y está completamente cifrado a través de claves dinámicas de su propia billetera con una fuerza equivalente a cualquier clave de transacción de blockchain pública.",
          apply: "Aplicar",
        },
        selector: {
          title: "Cambiar cuenta",
        },
      },
    },
  });

  window.walletStrings = walletStrings;
}

const detectLanguage = () => {
  const lang = navigator.language;
  // console.log("detectLanguage:", lang);
  if (lang.startsWith("zh")) {
    return "zh";
  } else if (lang.startsWith("en")) {
    return "en";
  } else if (lang.startsWith("es")) {
    return "es";
  } else {
    return "en";
  }
};

let lang = localStorage.getItem("language");
if (!lang || lang === "") {
  lang = detectLanguage();
}

if (lang !== "en" && lang !== "zh" && lang !== "es") {
  lang = "en";
}

window.walletStrings.setLanguage(lang);

const WalletStrings = window.walletStrings;
export default WalletStrings;
